"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: plaid/plaid-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fplaid%2Fplaid-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaidServiceClient = exports.RevokeAccessResponse = exports.RevokeAccessRequest = exports.EnableOtpCodeResponse = exports.EnableOtpCodeRequest = exports.HasOtpCodeResponse = exports.HasOtpCodeRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const protobufPackage = 'com.step.plaid.proto';
function createBaseHasOtpCodeRequest() {
    return {};
}
exports.HasOtpCodeRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.HasOtpCodeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseHasOtpCodeRequest();
        return message;
    },
};
function createBaseHasOtpCodeResponse() {
    return { expiresAtMs: '0' };
}
exports.HasOtpCodeResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.HasOtpCodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHasOtpCodeResponse();
        message.expiresAtMs = object.expiresAtMs ?? '0';
        return message;
    },
};
function createBaseEnableOtpCodeRequest() {
    return {};
}
exports.EnableOtpCodeRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnableOtpCodeRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnableOtpCodeRequest();
        return message;
    },
};
function createBaseEnableOtpCodeResponse() {
    return { code: '', expiresAtMs: '0' };
}
exports.EnableOtpCodeResponse = {
    fromJSON(object) {
        const message = {
            code: isSet(object.code) ? globalThis.String(object.code) : '',
            expiresAtMs: isSet(object.expiresAtMs) ? globalThis.String(object.expiresAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== '') {
            obj.code = message.code;
        }
        if (message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.EnableOtpCodeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnableOtpCodeResponse();
        message.code = object.code ?? '';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        return message;
    },
};
function createBaseRevokeAccessRequest() {
    return {};
}
exports.RevokeAccessRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RevokeAccessRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRevokeAccessRequest();
        return message;
    },
};
function createBaseRevokeAccessResponse() {
    return {};
}
exports.RevokeAccessResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RevokeAccessResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRevokeAccessResponse();
        return message;
    },
};
/**
 * Plaid public API.
 */
class PlaidServiceClient {
    rpc;
    name = 'com.step.plaid.proto.PlaidService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/plaid';
    methods = [{
            name: 'HasOtpCode',
            requestType: exports.HasOtpCodeRequest,
            responseType: exports.HasOtpCodeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'EnableOtpCode',
            requestType: exports.EnableOtpCodeRequest,
            responseType: exports.EnableOtpCodeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'RevokeAccess',
            requestType: exports.RevokeAccessRequest,
            responseType: exports.RevokeAccessResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    hasOtpCode(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    enableOtpCode(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    revokeAccess(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.PlaidServiceClient = PlaidServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=plaid-service.js.map